<template>
<div class="chapter">
<div class="inner_page">
<p class="title-head" id="Intro">Introduction</p>
<p class="para1">San Diego is often called “America’s Finest City.” After all, there are few other places in the fifty United States where you can find picture-perfect sandy beaches and surfer waves that stretch for miles, a sky that always looks like it’s painted blue, and the best weather—around 74 degrees all year.</p>
<p class="para">But, for all its beautiful views, there is something a bit darker beneath the surface of San Diego—it’s the place where the spirits of the past stick around and sometimes still make appearances. You see, San Diego is where California was born, meaning it’s quite an old city and with it comes a rich history that isn’t ready to go away just yet.</p>
<p class="para">It’s also a city that wants to make sure its famous spots from centuries ago are kept up, from old Navy ships and lighthouses to the many saloons, stores, and hotels. And yes, those who once visited and lived in these places still seem to hang around and “mingle” with those who visit today. So let’s begin our journey to this spooky coastal city and see what lurks under and above the water.</p>
<p class="image-center"><img alt="Image" src="images/P8.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Introduction.vue?a19137e8